import React from 'react';
import {r} from "@/utils/responsive";
import chaosMonsterAvatar from "@/assets/img/chaos_monster_avatar.png";
import chaosMonsterCardBg from "@/assets/img/chaos_card_bg.png";
import bgCardVideo from "@/assets/video/bg_card_video.mp4";
import DisabledWrapper from "@/components/DisabledWrapper";
import {S3_FILES} from "@/config/s3_files";
import ReactPlayerWrapper from "@/components/ReactPlayerWrapper";

interface ChaosMonsterCardProps extends React.HTMLAttributes<HTMLDivElement> {
}

const ChaosMonsterCard: React.FC<ChaosMonsterCardProps> = ({className, ...props}) => {
    return (
        <div
            {...props}
            style={{
                position: "relative",
                width: r.vmax(939),
                height: r.vmax(461),
                padding: `${r.vmax(145)} ${r.vmax(72)} 0`,
                color: '#ffffff',
                fontSize: r.vmax(28),
                lineHeight: r.vmax(36),
                whiteSpace: 'pre-wrap',
                marginTop: r.vmax(90),
            }}
        >
            {/* Невидимый SVG с определением clipPath */}
            <svg style={{position: 'absolute', width: 0, height: 0}}>
                <defs>
                    <clipPath id="card_video_mask_chaos" clipPathUnits="objectBoundingBox">
                        <path
                            d="M0 0.731C0 0.813 0 0.854 0.0125 0.879C0.0249 0.904 0.0449 0.904 0.0852 0.904H0.128H0.186H0.786C0.801 0.904 0.808 0.904 0.815 0.909C0.822 0.914 0.827 0.924 0.838 0.943L0.848 0.959C0.86 0.978 0.865 0.987 0.873 0.992C0.88 0.996 0.887 0.997 0.902 0.997H0.914C0.955 0.997 0.975 0.997 0.988 0.972C1 0.947 1 0.906 1 0.824V0.202C1 0.139 1 0.107 0.992 0.084C0.989 0.076 0.986 0.069 0.982 0.063C0.97 0.048 0.955 0.048 0.924 0.048C0.917 0.048 0.914 0.048 0.911 0.047C0.91 0.047 0.909 0.047 0.908 0.047C0.904 0.045 0.901 0.042 0.896 0.037L0.866 0.013C0.858 0.007 0.855 0.004 0.851 0.002C0.847 0 0.843 0 0.834 0H0.085C0.045 0 0.025 0 0.0125 0.025C0 0.051 0 0.092 0 0.174L0 0.731Z"
                        />
                    </clipPath>
                </defs>
            </svg>
            <img style={{
                pointerEvents: 'none',
                position: 'absolute',
                zIndex: 2,
                left: r.vmax(-16),
                top: r.vmax(-103),
                width: r.vmax(276),
                height: r.vmax(284),
            }} alt="" src={S3_FILES.MONSTER_CARD_AVATAR}/>
            <div style={{
                position: 'relative',
                zIndex: 2,
                display: 'flex',
                flexDirection: 'column',
                gap: r.vmax(20),
                letterSpacing: r.vmax(-0.20),
            }}>
                <p>{`Chaos Monster — порождение неправильных \nнастроек, потерянных секретов и replicas: 0.`}
                </p>
                <p>{`Он рвёт сети, убивает поды, перегружает ноды. \nНо победить его можно. Ведь тебя \nсопровождают MasterBot и YAML Oracle`}
                </p>

            </div>


            <DisabledWrapper>
                <img src={S3_FILES.MONSTER_CARD_BG} alt="" style={{
                    position: 'absolute',
                    inset: 0,
                    objectPosition: 'top',
                    objectFit: 'contain',
                    zIndex: 1,
                    opacity: .9
                }}/>

                <div style={{
                    position: 'absolute',
                    inset: 0,
                    clipPath: 'url(#card_video_mask_chaos)',
                }}>
                    <ReactPlayerWrapper videoSrc={S3_FILES.CHARACTER_CARD_BG_VIDEO}
                                        posterSrc={S3_FILES.CHARACTER_CARD_BG_VIDEO_POSTER} style={{

                        clipPath: 'url(#card_video_mask_chaos)',
                    }}/>
                </div>
            </DisabledWrapper>
        </div>
    );
};

export default ChaosMonsterCard;
